import axios, { AxiosResponse } from 'axios';

/**
 * Base url for the WordPress api
 */
export const wpApiInstance = axios.create({
  baseURL: '/wp-json/triton/v1'
});

wpApiInstance.interceptors.request.use( request => {
  // @ts-ignore
  request.headers['X-WP-Nonce'] = portal_nonce.api_rest_nonce;
  return request;
});

wpApiInstance.interceptors.response.use(response => {
  return response
}, error => {
  return error.response;
});

export const responseBody = (response: AxiosResponse) => response.data;